export default __webpack_public_path__ + "static/media/LHAFootballTeam5.fe1bdcae.png";